app.service('partnerSubscriptionsModal', function (modal, productCardManager) {

	let $checkboxes;

	function show(props) {
		const {content, onChange, partnerSubscriptionGroupId} = props;

		modal.generate({
			content,
			id: 'modal-partner-subscriptions',
			callbackOpen() {
				$checkboxes = $('input:checkbox[name=partnerSubscription]');
				$checkboxes.change(function () {
					onPartnerSubscriptionChange($(this).val(), partnerSubscriptionGroupId);
					onChange();
				});
				selectActiveSubscriptions();
			}
		});
	}

	function onPartnerSubscriptionChange(partnerSubscriptionId, partnerSubscriptionGroupId) {
		productCardManager.togglePartnerSubscription(parseInt(partnerSubscriptionId), parseInt(partnerSubscriptionGroupId));
	}

	function selectActiveSubscriptions() {
		$checkboxes
			.filter((i, checkbox) => productCardManager.hasPartnerSubscription(parseInt(checkbox.value)))
			.each((i, checkbox) => checkbox.checked = true);
	}

	return {
		show,
	};
});